/**
 * Sticky Header Navigation Bar
 * Locks the black navigation bar at 10px from viewport top on scroll down,
 * and releases back to default position when scrolling back to top.
 */

export const initStickyHeader = () => {
	const headerNavWrap = document.querySelector('.header-nav-wrap');
	const headerNavBar = document.querySelector('.header-nav-bar');
	const mainHeader = document.querySelector('.main-header');

	if (!headerNavWrap || !headerNavBar) {
		return;
	}

	let initialOffsetTop = 0;
	const lockOffset = 10;

	// Calculate initial position relative to the document
	const calculateInitialPosition = () => {
		if (!headerNavWrap.classList.contains('is-sticky')) {
			const rect = headerNavWrap.getBoundingClientRect();
			initialOffsetTop = rect.top + window.scrollY;
		}
	};

	const updateStickyState = () => {
		const scrollPosition = window.scrollY || window.pageYOffset;
		const threshold = Math.max(0, initialOffsetTop - lockOffset);

		if (scrollPosition > threshold) {
			if (!headerNavWrap.classList.contains('is-sticky')) {
				// Set placeholder min-height on wrapper to prevent layout shift
				headerNavWrap.style.minHeight = `${headerNavBar.offsetHeight}px`;
				headerNavWrap.classList.add('is-sticky');
				if (mainHeader) {
					mainHeader.classList.add('header-is-sticky');
				}
			}
		} else {
			if (headerNavWrap.classList.contains('is-sticky')) {
				headerNavWrap.classList.remove('is-sticky');
				headerNavWrap.style.minHeight = '';
				if (mainHeader) {
					mainHeader.classList.remove('header-is-sticky');
				}
			}
		}
	};

	// Use requestAnimationFrame for smooth scroll performance
	let ticking = false;
	const onScroll = () => {
		if (!ticking) {
			window.requestAnimationFrame(() => {
				updateStickyState();
				ticking = false;
			});
			ticking = true;
		}
	};

	const onResize = () => {
		if (!headerNavWrap.classList.contains('is-sticky')) {
			calculateInitialPosition();
		} else {
			headerNavWrap.style.minHeight = `${headerNavBar.offsetHeight}px`;
		}
		updateStickyState();
	};

	// Initial calculation
	calculateInitialPosition();
	updateStickyState();

	// Event listeners
	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onResize);
	window.addEventListener('orientationchange', () => {
		setTimeout(() => {
			calculateInitialPosition();
			updateStickyState();
		}, 150);
	});
};

export default initStickyHeader;
